import './App.css';
import HomePage from './pages/HomePage';
import {Routes,Route} from "react-router-dom"
import DetailPage from './pages/DetailPage';
import PageNotFound from './pages/PageNotFound';



function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={
          <HomePage/>
        }/>
        <Route path="/:id/:slug" element={<DetailPage/>}/>
        <Route path='*' element={<PageNotFound/>}/>
      </Routes>
    </div>
  );
}

export default App;
